import { components, OptionProps } from 'react-select';
import TimezoneFormat from '../TimezoneFormat';

interface Props
  extends OptionProps<{
    code: string;
    name: string;
    flag: string;
  }> {}

const Option: React.FC<Props> = ({ data, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option {...(props as OptionProps)}>
      <TimezoneFormat data={data} />
    </components.Option>
  );
};

export default Option;
